"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil_1 = require("../util/ClassUtil");
var IdentityKey_1 = require("../keys/IdentityKey");
var PublicKey_1 = require("../keys/PublicKey");
var CipherMessage_1 = require("./CipherMessage");
var Message_1 = require("./Message");
var InputError_1 = require("../errors/InputError");
var PreKeyMessage = (function (_super) {
    __extends(PreKeyMessage, _super);
    function PreKeyMessage() {
        var _this = _super.call(this) || this;
        _this.base_key = new PublicKey_1.default();
        _this.identity_key = new IdentityKey_1.default();
        _this.message = new CipherMessage_1.default();
        _this.prekey_id = -1;
        return _this;
    }
    PreKeyMessage.new = function (prekey_id, base_key, identity_key, message) {
        var pkm = ClassUtil_1.default.new_instance(PreKeyMessage);
        pkm.prekey_id = prekey_id;
        pkm.base_key = base_key;
        pkm.identity_key = identity_key;
        pkm.message = message;
        Object.freeze(pkm);
        return pkm;
    };
    PreKeyMessage.prototype.encode = function (encoder) {
        encoder.object(4);
        encoder.u8(0);
        encoder.u16(this.prekey_id);
        encoder.u8(1);
        this.base_key.encode(encoder);
        encoder.u8(2);
        this.identity_key.encode(encoder);
        encoder.u8(3);
        return this.message.encode(encoder);
    };
    PreKeyMessage.decode = function (decoder) {
        var prekey_id = null;
        var base_key = null;
        var identity_key = null;
        var message = null;
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    prekey_id = decoder.u16();
                    break;
                case 1:
                    base_key = PublicKey_1.default.decode(decoder);
                    break;
                case 2:
                    identity_key = IdentityKey_1.default.decode(decoder);
                    break;
                case 3:
                    message = CipherMessage_1.default.decode(decoder);
                    break;
                default:
                    decoder.skip();
            }
        }
        prekey_id = Number(prekey_id);
        if (!isNaN(prekey_id) && base_key && identity_key && message) {
            return PreKeyMessage.new(prekey_id, base_key, identity_key, message);
        }
        else {
            throw new InputError_1.default.TypeError("Given PreKeyMessage doesn't match expected signature.", InputError_1.default.CODE.CASE_406);
        }
    };
    return PreKeyMessage;
}(Message_1.default));
exports.default = PreKeyMessage;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/message/PreKeyMessage.js
// module id = 30
// module chunks = 0 1